import { Component, OnDestroy, OnInit } from '@angular/core';
import { ContextButtonService } from '../../common/services/context-button/context-button.service';
import { fadeIn } from '../../../animations/animations';
import { ActionButton } from '../../common/types/action-button';
import { CommonEvents } from '../../common/enums/common-events.enum';
import { BroadcastService } from '../../common/services/broadcast/broadcast.service';
import { ReplaySubject, Subscription } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

@Component({
    selector: 'cas-context-buttons',
    templateUrl: './context-buttons.component.html',
    styleUrls: ['./context-buttons.component.scss'],
    animations: [
        fadeIn
    ]
})
export class ContextButtonsComponent implements OnInit, OnDestroy {

    public buttons: ActionButton[] = [];

    private overflowButtonsSubject = new ReplaySubject<ActionButton[]>(1);
    private nonMenuButtonsSubject = new ReplaySubject<ActionButton[]>(1);
    private hasOverflowButtonsSubject = new ReplaySubject<boolean>(1);

    public overflowButtons$ = this.overflowButtonsSubject.asObservable();
    public nonMenuButtons$ = this.nonMenuButtonsSubject.asObservable();
    public hasOverflowButtons$ = this.hasOverflowButtonsSubject.asObservable();

    private subscriptions = new Subscription();
    private buttonPanelSubscription: Subscription;
    private handleButtonsSubscription: Subscription;

    constructor(
        private contextButtonService: ContextButtonService,
        private broadcastService: BroadcastService) {
    }

    public ngOnInit(): void {
        this.initButtons();
        const handleButtons$ = this.contextButtonService.maxVisibleButtonsCountObservable()
            .pipe(tap(visibleButtonsCount => this.notifyButtonsChanged(visibleButtonsCount)));

        this.buttonPanelSubscription = this.broadcastService.on(CommonEvents.ButtonPanel)
            .pipe(
                tap(() => this.initButtons()),
                switchMap(() => handleButtons$)
            ).subscribe();

        this.handleButtonsSubscription = handleButtons$
            .subscribe();

        this.subscriptions.add(this.buttonPanelSubscription);
        this.subscriptions.add(this.handleButtonsSubscription);
    }

    private notifyButtonsChanged(visibleCount: number) {
        this.hasOverflowButtonsSubject.next(this.buttons.length > visibleCount);
        const overflowCompensation = this.buttons.length > visibleCount ? 1 : 0;
        this.nonMenuButtonsSubject.next(this.buttons.slice(0, visibleCount - overflowCompensation));
        this.overflowButtonsSubject.next(this.buttons.slice(visibleCount - overflowCompensation));
    }

    private initButtons() {
        if (!this.contextButtonService.buttons) {
            this.buttons = [];
        } else {
            this.buttons = this.contextButtonService.buttons.filter(button => !button.isHidden());
        }
    }

    public ngOnDestroy() {
        this.buttonPanelSubscription.unsubscribe();
        this.handleButtonsSubscription.unsubscribe();
        this.subscriptions.unsubscribe();
    }
}
